/**
 * Helpers for the Launcher Settings preview panel.
 * The preview is a uniformly scaled device frame driven by Width/Height (px).
 */

export function fitDeviceFrame(stageWidth, stageHeight, deviceWidth, deviceHeight, padding = 8) {
  const availW = Math.max(Number(stageWidth) - padding, 1);
  const availH = Math.max(Number(stageHeight) - padding, 1);
  const dw = Math.max(Number(deviceWidth) || 0, 1);
  const dh = Math.max(Number(deviceHeight) || 0, 1);
  const scale = Math.min(availW / dw, availH / dh);
  return {
    width: Math.max(1, Math.round(dw * scale)),
    height: Math.max(1, Math.round(dh * scale)),
    scale,
  };
}

export function matchGridPreset(presets, { columns, rows, iconSize, gap }) {
  const found = Object.entries(presets || {}).find(([key, cfg]) => (
    key !== 'custom'
    && cfg
    && cfg.columns === columns
    && cfg.rows === rows
    && cfg.iconSize === iconSize
    && cfg.gap === gap
  ));
  return found ? found[0] : 'custom';
}

const ICON_PIXEL_MAP = {
  small: 60,
  medium: 80,
  large: 100,
  xlarge: 120,
};

export function estimateVisibleRows({ viewportHeight, rows, iconSize, gap }) {
  const iconPx = ICON_PIXEL_MAP[iconSize] || 80;
  const gapPx = (Number(gap) || 0) * 8;
  const rowHeightPx = iconPx + gapPx * 2 + 24;
  const safeRows = Math.max(Number(rows) || 0, 0);
  if (rowHeightPx <= 0 || !viewportHeight) {
    return { visibleRows: safeRows, willOverflow: false };
  }
  const approx = viewportHeight / rowHeightPx;
  const clamped = Math.max(0, Math.min(safeRows, approx));
  return {
    visibleRows: clamped,
    willOverflow: clamped + 0.05 < safeRows,
  };
}
